import { growthMedia } from "@/shared/components/enum-labels";
import { Card } from "@/shared/components/ui/card";
import { formatDate } from "@/shared/utilities/date";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { de } from "date-fns/locale";
import { ReactElement } from "react";
import { Sample } from "@/services/backend/sample-set/sample-set";
import ErrorBadge from "@/shared/components/domain/samples/error-badge";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { hasFieldError } from "@/shared/app-lib/errors/validation-error";

interface SampleDetailRowProps {
  samples: Sample[];
}

function SampleDetailRow({ samples }: SampleDetailRowProps): ReactElement {
  if (samples.length === 0) {
    return <div>Keine Proben gefunden</div>;
  }

  return (
    <div className="flex flex-col space-y-4">
      <Card className="shadow-none">
        <Table>
          <SampleDetailRowHeader />
          <SampleDetailRowBody samples={samples} />
        </Table>
      </Card>
    </div>
  );
}

function SampleDetailRowHeader() {
  return (
    <TableHeader className="border-b border-gray-200">
      <TableRow>
        <TableHead>Nährmedium</TableHead>
        <TableHead>Beginn der Probenahme</TableHead>
        <TableHead>Charge</TableHead>
        <TableHead>Ablaufdatum</TableHead>
        <TableHead>Probenfehler</TableHead>
      </TableRow>
    </TableHeader>
  );
}

function SampleDetailRowBody({ samples }: { samples: Sample[] }) {
  const { notReadyError } = useErrArtefactNotReady();

  return (
    <TableBody>
      {samples.map((sample) => {
        const hasBatchError = hasFieldError(
          notReadyError,
          `samples.${sample.id}.batchId`,
        );

        return (
          <TableRow key={sample.id}>
            <TableCell>{growthMedia[sample.growthMedium]}</TableCell>
            <TableCell>{formatDate(sample.createdAt, de)}</TableCell>
            <TableCell
              className={
                hasBatchError ? "rounded-lg border border-red-500" : ""
              }
            >
              {sample.batch != null && sample.batch.originalId != null
                ? sample.batch?.batchNumber
                : "Keine Charge zugewiesen"}
            </TableCell>
            <TableCell>
              {sample.batch != null && sample.batch.originalId != null
                ? formatDate(sample.batch.expiryDate)
                : "Keine Charge zugewiesen"}
            </TableCell>
            <TableCell>
              <div className="flex flex-row space-x-1">
                {sample.sampleErrors.map((err) => (
                  <ErrorBadge key={err.originalId} sampleError={err} />
                ))}
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
}

export default SampleDetailRow;
